export default __webpack_public_path__ + "static/mask-ce5b0970b9e6f88156ab1f9c808c49a5.svg";